export default __webpack_public_path__ + "static/media/meal-1.b0d6c569.svg";